import { Suspense } from "react";
import { Layout } from "@/modules/layout/layout";
import { PageSkeleton } from "@/components/skeletons/PageSkeleton";
import { ProtectedRoute } from "@/lib/protected-route";
import { RouteComponentProps } from "wouter";

interface PrivateMenuLayoutRouteProps {
  path: string;
  moduleKey: string;
  component: React.ComponentType<RouteComponentProps>;
  title: string;
}

export function PrivateMenuLayoutRoute({
  component: Component,
  title,
  ...rest
}: PrivateMenuLayoutRouteProps) {
  return (
    <ProtectedRoute
      {...rest}
      component={(props) => (
        <Layout title={title}>
          <Suspense fallback={<PageSkeleton />}>
            <Component {...props} />
          </Suspense>
        </Layout>
      )}
    />
  );
}